var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "centermodel" }, [
      _c("div", { staticClass: "top344" }, [
        _c("div", { staticClass: "shopInfo" }, [
          _c("span", { staticClass: "shopMingzi" }, [
            _vm._v(_vm._s(_vm.shopName))
          ]),
          _vm._v(" "),
          _c("div", { attrs: { shopjieshao: "" } }, [
            _vm.shopIntroduce
              ? _c("span", { staticClass: "shopProduct" }, [
                  _vm._v(_vm._s(_vm.shopIntroduce))
                ])
              : _c(
                  "span",
                  {
                    staticStyle: { "font-size": "16px", "margin-top": "20px" }
                  },
                  [_vm._v("该企业未填写店铺简介哦~")]
                )
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "extBox" }, [
        _c("div", { staticClass: "entTitle" }, [_vm._v("企业工商信息")]),
        _vm._v(" "),
        _vm.formData
          ? _c("div", [
              _c("span"),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "font-size": "16px",
                    color: "#f77b0b",
                    "text-align": "center"
                  }
                },
                [
                  _vm._v(
                    "\n          前往“全国工商局查询系统”核实信息>\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "entTable", staticStyle: { width: "100%" } },
                [
                  _c("tr", [
                    _c("th", [_vm._v("公司名称:")]),
                    _vm._v(" "),
                    _vm.formData.enterpriseName ||
                    _vm.formData.otherName ||
                    _vm.formData.subjectName
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formData.enterpriseName ||
                                  _vm.formData.otherName ||
                                  _vm.formData.subjectName
                              ) +
                              "\n            "
                          )
                        ])
                      : _c("td", [_vm._v("暂无")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("企业类型:")]),
                    _vm._v(" "),
                    _vm.formData.authenType == 2
                      ? _c("td", [_vm._v("个体经营户")])
                      : _vm.formData.authenType == 3
                      ? _c("td", [_vm._v("企业用户")])
                      : _vm.formData.authenType == 4
                      ? _c("td", [_vm._v("事业单位或社会团体")])
                      : _c("td", [_vm._v("暂无")])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("统社会信用代码:")]),
                    _vm._v(" "),
                    _vm.formData.enterpriseCode ||
                    _vm.formData.otherCode ||
                    _vm.formData.subjectCode
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formData.enterpriseCode ||
                                  _vm.formData.otherCode ||
                                  _vm.formData.subjectCode
                              ) +
                              "\n            "
                          )
                        ])
                      : _c("td", [_vm._v("暂无")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("法定代表人:")]),
                    _vm._v(" "),
                    _vm.formData.enterpriseOperator
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formData.enterpriseOperator) +
                              "\n            "
                          )
                        ])
                      : _c("td", [_vm._v("暂无")])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("成立日期:")]),
                    _vm._v(" "),
                    _vm.formData.enterpriseStartTime ||
                    _vm.formData.otherStartTime ||
                    _vm.formData.subjectStartTime
                      ? _c("td", { attrs: { colspan: "3" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formData.enterpriseStartTime ||
                                  _vm.formData.otherStartTime ||
                                  _vm.formData.subjectStartTime
                              ) +
                              "\n            "
                          )
                        ])
                      : _c("td", [_vm._v("暂无")])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("注册地址:")]),
                    _vm._v(" "),
                    _vm.formData.enterpriseRegion ||
                    _vm.formData.otherRegion ||
                    _vm.formData.subjectRegion
                      ? _c("td", { attrs: { colspan: "3" } }, [
                          _vm.formData.enterpriseRegion ||
                          _vm.formData.otherRegion ||
                          _vm.formData.subjectRegion
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formData.enterpriseRegion ||
                                        _vm.formData.otherRegion ||
                                        _vm.formData.subjectRegion
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formData.enterpriseAdress ||
                          _vm.formData.otherAdress ||
                          _vm.formData.subjectAdress
                            ? _c("span")
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formData.enterpriseAdress ||
                                  _vm.formData.otherAdress ||
                                  _vm.formData.subjectAdress
                              ) +
                              "\n            "
                          )
                        ])
                      : _c("td", [_vm._v("暂无")])
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "extBox" }, [
          _c("div", { staticClass: "entTitle" }, [_vm._v("企业资质证书")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "swiper",
                { staticClass: "swiper", attrs: { options: _vm.swiperOption } },
                _vm._l(_vm.imgList, function(item) {
                  return _c(
                    "swiper-slide",
                    { key: item, staticClass: "swiper-slide" },
                    [
                      _c("div", { staticClass: "swiper-content" }, [
                        _c("img", { attrs: { src: item, alt: "" } })
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "renzhengInfo" }, [
      _c("div", { staticClass: "shopQiye" }, [
        _c("img", {
          staticClass: "qiye",
          attrs: {
            src: require("../../assets/images/qiyerenzheng.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "qiyelable" }, [_vm._v("企业真实性已检验")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shopApply" }, [
        _c("img", {
          staticClass: "apply",
          attrs: {
            src: require("../../assets/images/shenqinrenhzeng.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "applyLable" }, [_vm._v("申请人身份已检验")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-e62db67e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e62db67e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/dossier.vue
// module id = null
// module chunks = 